import {
  CreditCardIcon,
  DesktopComputerIcon,
  DocumentTextIcon,
  HomeIcon,
  PhoneIncomingIcon,
  UserAddIcon,
  UserCircleIcon,
  BellIcon,
  IdentificationIcon
} from '@heroicons/vue/outline'

import { useTenant } from '@/Hooks/Shared/useTenant'

export default function useNavigation() {
  const { tenant } = useTenant()

  return {
    overviewRouteName: null,
    sections: [
      {
        show: true,
        name: null,
        description: null,
        children: [
          {
            show: true,
            name: 'Dashboard',
            description: null,
            routeIsInertia: true,
            targetRouteName: 'web.customer.dashboard.show',
            icon: DesktopComputerIcon,
            routeNamesToCheckIfCurrent: ['web.customer.dashboard.*']
          }
        ]
      },
      {
        show: true,
        name: 'General',
        description: null,
        children: [
          {
            show: true,
            name: 'Listings',
            description: null,
            routeIsInertia: true,
            targetRouteName: 'web.customer.listings.index',
            icon: HomeIcon,
            routeNamesToCheckIfCurrent: ['web.customer.listings.*']
          },
          {
            show: true,
            name: 'Orders',
            description: null,
            routeIsInertia: true,
            targetRouteName: 'web.customer.orders.index',
            icon: DocumentTextIcon,
            routeNamesToCheckIfCurrent: ['web.customer.orders.*']
          },
          {
            show: tenant.value.features.show_leads_menu_item,
            name: 'Leads',
            description: null,
            routeIsInertia: true,
            targetRouteName: 'web.customer.leads.index',
            icon: PhoneIncomingIcon,
            routeNamesToCheckIfCurrent: ['web.customer.leads.*']
          }
        ]
      },
      {
        show: true,
        name: tenant.value.features.can_manage_team_members ? 'Team Settings' : 'Settings',
        description: null,
        children: [
          {
            show: tenant.value.features.can_manage_team_members,
            name: 'Team',
            description: null,
            routeIsInertia: true,
            targetRouteName: 'web.customer.customer-team-members.index',
            icon: UserAddIcon,
            routeNamesToCheckIfCurrent: ['web.customer.customer-team-members.*']
          },
          {
            show: true,
            name: 'Notifications',
            description: null,
            routeIsInertia: true,
            targetRouteName: 'web.customer.notifications.settings.index',
            icon: BellIcon,
            routeNamesToCheckIfCurrent: ['web.customer.notifications.settings.*']
          },
          {
            show: true,
            name: 'Payment Cards',
            description: null,
            routeIsInertia: true,
            targetRouteName: 'web.customer.payments.settings.payment-methods.index',
            icon: CreditCardIcon,
            routeNamesToCheckIfCurrent: ['web.customer.payments.settings.payment-methods.*']
          },
          {
            show: true,
            name: 'Social Profile Links',
            description: "Update your group's social profile links.",
            routeIsInertia: true,
            targetRouteName: 'web.customer.social-profiles.edit',
            icon: IdentificationIcon,
            routeNamesToCheckIfCurrent: ['web.customer.social-profiles.*']
          },
          {
            show: !tenant.value.features.can_manage_team_members,
            name: 'User Details',
            description: 'Update your user details such as login email and password.',
            routeIsInertia: true,
            targetRouteName: 'web.customer.auth-customer-user.show',
            icon: UserCircleIcon,
            routeNamesToCheckIfCurrent: ['web.customer.auth-customer-user.*']
          },
          {
            show: !tenant.value.features.can_manage_team_members,
            name: 'Notification Preferences',
            description: 'Configure your notification preferences.',
            routeIsInertia: true,
            targetRouteName: 'web.customer.notifications.preferences.edit',
            icon: BellIcon,
            routeNamesToCheckIfCurrent: ['web.customer.notifications.preferences.edit']
          }
        ]
      },
      {
        show: tenant.value.features.can_manage_team_members,
        name: 'Personal Settings',
        description: null,
        children: [
          {
            show: true,
            name: 'User Details',
            description: 'Update your user details such as login email and password.',
            routeIsInertia: true,
            targetRouteName: 'web.customer.auth-customer-user.show',
            icon: UserCircleIcon,
            routeNamesToCheckIfCurrent: ['web.customer.auth-customer-user.*']
          },
          {
            show: true,
            name: 'Notification Preferences',
            description: 'Configure your notification preferences.',
            routeIsInertia: true,
            targetRouteName: 'web.customer.notifications.preferences.edit',
            icon: BellIcon,
            routeNamesToCheckIfCurrent: ['web.customer.notifications.preferences.edit']
          }
        ]
      }
    ]
  }
}
